import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";
import MilitaryRegistration from "./tabs/MilitaryRegistration";

const militaryTabs = [
  {
    title: "Основные данные",
    component: <MilitaryRegistration />,
  },
];

const Military: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {militaryTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {militaryTabs[tab].component}
    </Wrapper>
  );
};

export default Military;
